export default __webpack_public_path__ + "static/media/frame-wood-smiley.17c0e027.png";